import Icon from "../../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../../userPreferences/staticWords";
import Button from "../../sharedComponents/buttons/button";

const AdminDetailsCard = ({
  rowInfo,
  setRowInfo,
  listType,
  modalVisible,
  setModalVisible,
}) => {
  let generalItem = [];
  return (
    <>
      {rowInfo.show ? (
        <>
          <div className="d-flex justify-content-around py-3">
            <div className="fw-bold">{"التفاصيل"}</div>
            <div
              onClick={() => {
                unSelectRow();
                setRowInfo({ show: false, id: null, userData: {} });
              }}
            >
              <Icon name="times" size={22} color={"rgb(12, 87, 76)"} />
            </div>
          </div>
          <div className="d-flex align-items-center col-9 justify-content-start container">
            <div className="col-4 h-100">
              {Object.keys(rowInfo?.userData).map((item, index) => {
                if (item == "id" || item == "logo") {
                  generalItem.push(index);
                } else
                  return (
                    <div key={item} className="py-1 ">
                      {Lang[item]}
                    </div>
                  );
              })}
            </div>
            <div className="h-100">
              {Object.values(rowInfo?.userData).map((item, index) => {
                if (!generalItem.includes(index))
                  return (
                    <div className="py-1" key={index}>
                      {item
                        ? item === true
                          ? "نعم"
                          : item === false
                          ? "لا"
                          : item
                        : "لايوجد"}
                    </div>
                  );
              })}
            </div>
          </div>
          <div className="d-flex align-items-center col-9 justify-content-start container py-3">
            {listType == "users" && (
              <>
                <Button
                  containerStyle={"col-3 mx-2"}
                  content={"تعديل"}
                  id={rowInfo.id}
                  onClick={() => {
                    setModalVisible({
                      ...modalVisible,
                      ediUser: !modalVisible.ediUser,
                      helperData: { id: rowInfo.id },
                    });
                  }}
                />
                <Button
                  containerStyle={"col-3 mx-2"}
                  content={"حذف"}
                  id={rowInfo.id}
                  onClick={() => {
                    setModalVisible({
                      ...modalVisible,
                      deleteUser: !modalVisible.deleteUser,
                      helperData: { id: rowInfo.id },
                    });
                  }}
                />
                {/* <Button
                  containerStyle={"col-5 mx-2"}
                  content={"ضبط الصلاحيات"}
                  id={rowInfo.id}
                  onClick={() => {
                    setModalVisible({
                      ...modalVisible,
                      addRole: !modalVisible.addRole,
                      helperData: { id: rowInfo.id },
                    });
                  }}
                /> */}
              </>
            )}

            {listType == "communities" && (
              <>
                <Button
                  containerStyle={"col-3 mx-2"}
                  content={"تعديل"}
                  id={rowInfo.id}
                  onClick={() => {
                    setModalVisible({
                      ...modalVisible,
                      editCommunity: !modalVisible.editCommunity,
                      helperData: { id: rowInfo.id },
                    });
                  }}
                />
                <Button
                  containerStyle={"col-3 mx-2"}
                  content={"حذف"}
                  id={rowInfo.id}
                  onClick={() => {
                    setModalVisible({
                      ...modalVisible,
                      deleteCommunity: !modalVisible.deleteCommunity,
                      helperData: { id: rowInfo.id },
                    });
                  }}
                />
                {/* <Button
                  containerStyle={"col-5 mx-2"}
                  content={"اضافة اعضاء"}
                  id={rowInfo.id}
                  onClick={() => {
                    setModalVisible({
                      ...modalVisible,
                      addUser: !modalVisible.addUser,
                      helperData: { id: rowInfo.id, data: rowInfo },
                    });
                  }}
                /> */}
              </>
            )}
            {listType == "lookups" && (
              <>
                <Button
                  containerStyle={"col-3 mx-2"}
                  content={"تعديل"}
                  id={rowInfo.id}
                  onClick={() => {
                    setModalVisible({
                      ...modalVisible,
                      editLookup: !modalVisible.editLookup,
                      helperData: { data: rowInfo?.userData },
                    });
                  }}
                />
                <Button
                  containerStyle={"col-3 mx-2"}
                  content={"حذف"}
                  id={rowInfo.id}
                  onClick={() => {
                    setModalVisible({
                      ...modalVisible,
                      deleteLookup: !modalVisible.deleteLookup,
                      helperData: { id: rowInfo.id },
                    });
                  }}
                />
              </>
            )}
          </div>
        </>
      ) : null}
    </>
  );
};

export default AdminDetailsCard;

const unSelectRow = () => {
  let list = document.getElementsByClassName("table-row");
  for (let i = 0; i < list.length; i++) {
    const element = list.item(i);
    if (element.classList.contains("table-row")) {
      element.classList.remove("selectedtr");
    }
  }
};
